import { Box, BoxProps, ColorOptions, ModBox, Text, TextNew } from '@jfs/ui-new';
import { Colors } from '../../../util/util';

export interface BillItemType {
  item: { label: string; value: string }
  index: number
}

const BillItem = ({ item, index }: BillItemType) => {
  if (item?.value === 'Separator') {
    return <Box {...styles.lineView} />
  }
  return (
    <Box
      key={index + '_' + item?.label}
      marginVertical={8}
      minHeight={20}
      flexDirection="row"
      justifyContent={'space-between'}>
      <Box width={'60%'}>
        <Text fontSize={14} lineHeight={20} fontFamily="JioType-Medium" color={Colors.PRIMARY_GREY}>
          {item?.label}
        </Text>
        <ModBox show={item?.label === 'Agent Fee Amount'}>
          <Text lineHeight={16} color={Colors.PRIMARY_GREY} fontSize={12} fontFamily="JioType-Medium">
            {item?.label === 'Agent Fee Amount' ? '(Chargable to customer)' : ''}
          </Text>
        </ModBox>
        <ModBox show={item?.label === 'Total Amount'}>
          <Text lineHeight={16} color={Colors.PRIMARY_GREY} fontSize={12} fontFamily="JioType-Medium">
            {item?.label === 'Total Amount' ? '(Amount to be collected from Customer)' : ''}
          </Text>
        </ModBox>
      </Box>
      <Box width={'40%'} alignItems="flex-end">
        <TextNew
          fontSize={14}
          lineHeight={20}
          fontFamily="JioType-Medium"
          color={item?.label === 'Agent Fee Amount' ? ('#00B259' as ColorOptions) : 'BLACK_21'}>
          {item?.label === 'Agent Fee Amount' ? item?.value : item?.value?.toUpperCase()}
        </TextNew>
      </Box>
    </Box>
  )
}
const styles = {
  lineView: {
    flex: 1,
    marginVertical: 8,
    height: 0.5,
    backgroundColor: 'LIGHT_GREY_SEPARATOR',
  } as BoxProps,
}

export { BillItem };

